import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import { useImpersonateUserMutation } from 'api/main';
import { parseFullName, parseSum } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import { ActionButton, StyledTableRow } from 'components';
import { Link, TableCell, Typography } from '@mui/material';

const OngoingSubscriptionRow = ({ subscription, type, userIsAdmin }) => {
    const [impersonateUser, { isLoading: impersonateLoading }] = useImpersonateUserMutation();

    const handleContinueSubscription = useCallback(() => {
        const followupPath =
            subscription.user?.subscriptions?.length > 1 ? '/new-subscription' : '';
        impersonateUser({
            indirectSubscription: true,
            userId: subscription.user.id,
            followupPath,
        });
    }, [impersonateUser, subscription]);

    const detailsPath = `subscriptions/details/${subscription.user?.id}/${subscription.id}`;

    return (
        <StyledTableRow key={subscription.id}>
            <TableCell sx={theme => ({ color: theme.palette.common.black })}>
                {subscription.role?.name?.includes('PP') ? (
                    <React.Fragment>
                        <Typography gutterBottom fontSize="inherit">
                            {parseFullName(subscription.user)}
                        </Typography>
                        {subscription.coSubscriber ? (
                            <Typography fontSize="inherit">
                                {parseFullName(subscription.coSubscriber)}
                            </Typography>
                        ) : (
                            ''
                        )}
                    </React.Fragment>
                ) : (
                    subscription.user?.investorCompany?.corporateName
                )}
            </TableCell>
            <TableCell>{subscription.investmentFund?.name || ''}</TableCell>
            <TableCell sx={theme => ({ color: theme.palette.common.black })}>
                <b>{parseSum(subscription?.investmentCharacteristics?.investingSum)}</b>
            </TableCell>
            {userIsAdmin && <TableCell>{parseFullName(subscription.createdBy)}</TableCell>}
            {type === 'untransferred' && (
                <TableCell align="center">
                    <ActionButton
                        sx={{ padding: 1 }}
                        loading={impersonateLoading}
                        onClick={handleContinueSubscription}
                    >
                        {texts.CONTINUER}
                    </ActionButton>
                </TableCell>
            )}
            {type === 'transferred' && (
                <React.Fragment>
                    <TableCell>{subscription.user.phoneNumber}</TableCell>
                    <TableCell>{subscription.user.email}</TableCell>
                    <TableCell>
                        <Link
                            href={detailsPath}
                            to={detailsPath}
                            component={RouterLink}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: 'inherit',
                                textDecoration: 'none',
                                width: '100%',
                                '&:hover': { textDecoration: 'underline' },
                            }}
                        >
                            {subscription.userFriendlyStatus}
                        </Link>
                    </TableCell>
                </React.Fragment>
            )}
        </StyledTableRow>
    );
};

OngoingSubscriptionRow.propTypes = {
    subscription: PropTypes.object.isRequired,
    userIsAdmin: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['untransferred', 'transferred']),
};

export default OngoingSubscriptionRow;
